import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'

import { selectIsAuthenticated } from 'modules/user/selectors'
import { useIsPreviewing } from '@builder.io/react'

export const PrivateRoute = ({ isAuthenticated, ...rest }) => {
  const isPreviewingInBuilder = useIsPreviewing() || new URLSearchParams(window.location.search).has('builder.preview')

  return (isAuthenticated || isPreviewingInBuilder) ? <Route {...rest} /> : <Redirect to="/login" />
}

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: selectIsAuthenticated,
})

export default connect(mapStateToProps)(PrivateRoute)
